'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var appTheme_model = require('./app-theme.model.js');



exports.THEMES = appTheme_model.THEMES;
